<template>
  <div class="w100 po-r bg-w pt20 pb20 pl20 pr20">
    <div class="w100 mb20 cl-f">
      <span class="font-16">意见反馈</span>
      <!-- <div class="flex-box fr">
        <el-input class="mr10" placeholder="查询" size="mini" prefix-icon="el-icon-search" v-model="searchText" @keyup.enter.native="initPage" clearable></el-input>
        <el-button type="primary" size="mini" @click="initPage">查询</el-button>
      </div> -->
    </div>

    <div class="w100 po-r pt20">
      <el-table class="w100 tx-c my-table" :data="list" stripe border>
        <el-table-column align="center" label="序号" width="60px">
          <template slot-scope="scope">
            {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" label="标题" prop="title"></el-table-column>
        <el-table-column align="center" label="内容" prop="content"></el-table-column>
        <el-table-column align="center" label="提交时间" width="150px">
          <template slot-scope="scope">
            {{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="附件" width="100px">
          <template slot-scope="scope">
            <span class="blue cu-p" v-if="scope.row.fileId" @click="download(scope.row)">{{ scope.row.fileName}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </div>
    <a class="none" ref="downloadExcel" :href="downloadUrl"></a>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Feedback",
  components: {},
  props: [],
  data() {
    return {
      loading: false,

      searchText: "",
      pageNum: 1,
      pageSize: 20,
      total: 0,
      list: [],

      awsUrl: "",
      isShowAws: false,

      downloadUrl: ""
    };
  },
  computed: {
    ...mapState(["userToken"])
  },
  created() {},
  mounted() {
    this.initPage();
  },
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "viewCollect/query",
          JSON.stringify({
            processDefId: this.$route.params.id,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }),
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            }
          }
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "页面请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    download(item) {
      this.downloadUrl =
        this.$http.defaults.baseURL +
        "uploader/file/download/" +
        item.fileId +
        "?token=" +
        this.userToken;
      this.$nextTick(() => {
        this.$refs.downloadExcel.click();
      });
    }
  },
  watch: {}
};
</script>

<style scoped>
</style>
